(function ($) {
  $(function () {
     $('.button-collapse').sideNav();
      $('.collapsible').collapsible();
    var searchIcon = $( "#search-icon" );
        var searchBar = $( "#search-bar" );
        searchIcon.on("click",function ( event ) {
            searchBar.removeClass("hide-on-med-and-up");
          searchIcon.addClass("hide");

        });
  });
})(jQuery);